import { createActionTypes } from "../../helpers/utils/createActionTypes";

export const LOGO = {
  GET_LISTA_LOGO: createActionTypes("GET_LISTA_LOGO"),
  GET_LOGO: createActionTypes("GET_LOGO"),
  SAVE_LOGO: createActionTypes("SAVE_LOGO"),
  GET_LOGO_HISTORY: createActionTypes("GET_LOGO_HISTORY"),
  GET_LOGO_HISTORY_LIST: createActionTypes("GET_LOGO_HISTORY_LIST"),
  GET_LOGO_ALL: createActionTypes("GET_LOGO_ALL"),

  LOAD_EMPTY_LOGO: "LOAD_EMPTY_LOGO",
  CLEAN_MESSAGE_LOGO: "CLEAN_MESSAGE_LOGO",
  CHANGE_PAGE_SIZE_LOGO: "CHANGE_PAGE_SIZE_LOGO"
};
